<template>
    <PopupRouterView :showLeftIcon="true" label="Combine Case Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="combinecase"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="combineCaseInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-label label-cols-lg="12" size="sm" label="Combine Date" :model="formattedCombineDate" />
						<app-input-scan :disabled="remainingQty == 0" id="fieldset-scan-control-card" ref="fieldset-scan-control-card" :model.sync="controlCardQrCode" label="Control Card" @scannedMethod="scanControlCard" :isBusy="isScanControlCardLoading" autofocus />
					</b-col>
					<b-col cols="12" lg="6">
						<!-- <app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="fieldset-control-card" size="sm" :model.sync="model.controlCardId" :isRequired="true" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" @change="onControlCardChange"  /> -->
						<!-- <app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId" :isRequired="true" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" @change="updateData"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" /> -->
						<app-label label-cols-lg="12" size="sm" label="Part Number" :model="(model.part != null) ? model.part.partNumber : null"  />
						<app-label label-cols-lg="12" size="sm" label="Combine Qty" :model="(model.part != null) ? model.part.standarPackagingQty : null"  />
					</b-col>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(model.part != null) ? model.part.partName : null"  />
						<app-label label-cols-lg="12" size="sm" label="Remaining Qty" :model="remainingQty" />
					</b-col>
					<b-col cols="12">
						<span>Control Card Scanned</span>
						<div id="container-table-combine-case">
							<b-table id="table-list-combine-case" :class="'table-action'" head-variant="head-light"
							:bordered="true" :items="model.combineCaseDetail" :fields="fieldsCombineCaseDetail"  small responsive show-empty tbody-tr-class="rowClass">
								<template v-slot:cell(frontActions)="row" >
									<b-overlay
										:show="isBusy"
										rounded
										opacity="0.6"
										spinner-small
										spinner-variant="primary"
										class="d-inline-block"
										>
										<click-confirm>
										<b-button size="sm" variant="danger" @click="resetData(row.item.id)" class="mr-2 btn-xs">
											<b-icon-trash></b-icon-trash>
										</b-button>
										</click-confirm>
									</b-overlay>
								</template>
							</b-table>
							<!-- <app-table-input 
								:bordered="true" :items="model.combineCaseDetail" 
								:fields="fieldsCombineCaseDetail" 
								:busy="isDataLoading" 
								:sort-by.sync="sortByCombineCaseDetail" 
								:sort-desc.sync="sortDescCombineCaseDetail"	
								@editButtonMethod="editRowDataCombineCaseDetail"	
								@deleteButtonMethod="resetData"	
								@showPopupAddMethod="addDataCombineCaseDetail()"	
								@showPopupUploadMethod="showPopupUploadCombineCaseDetail()"
								@downloadMethod="downloadCombineCaseDetail()"
								@addFromClipboardMethod="addFromClipboardCombineCaseDetail()"
								@replaceFromClipboardMethod="replaceFromClipboardCombineCaseDetail()"
								:showActionButton="true"
								:showDeleteButton="true"
								:showAddButton="false"
								:showAddFromClipboardButton="false"	
								:showReplaceFromClipboardButton="false"	
								:showUploadButton="false"	
								:showDownloadButton="false"	
								:isDownloadBusy="isDownloadCombineCaseDetail"
							>
													
								<template v-slot:cell(no)="row">
									{{ ((row.index + 1) + ( combineCaseDetailPageSize * (currentCombineCaseDetailPage - 1))) }}
								</template>
													
								<template v-slot:table-busys>
									<div class="text-center my-2">
										<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading...</strong>
									</div>
								</template>
													
								<template v-slot:cell(controlCard)="row">
									<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-combine-case-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"  @change="saveInputCombineCaseDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"    :nolabel="true" />
								</template>
								<template v-slot:cell(qtyControlCard)="row">
									<app-input-textbox :id="'input-combine-case-detail-qty-control-card-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qtyControlCard"   @change="saveInputCombineCaseDetail(row.item)" :isEditable="false" :isUpdateable="false" :nolabel="true" />
								</template>
								<template v-slot:cell(takenQty)="row">
									<app-input-textbox :id="'input-combine-case-detail-taken-qty-' + row.index" label-cols-lg="12" label="Taken Qty" size="sm" :model.sync="row.item.takenQty"   @change="saveInputCombineCaseDetail(row.item)" :isEditable="false" :isUpdateable="false" :nolabel="true" />
								</template>

													
							</app-table-input> -->
						</div>
					</b-col>
				</b-row>
			</span>

        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
        <template #modal-action-button>
			<b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right" @click="addAndPrint()">Add & Print</b-button>

        </template>
		<CombineCaseDetailScan
			:parentLabelInfo="parentLabelInfo"
			:parentValueInfo="parentValueInfo"
			:model="modelCombineCaseDetail"
			:modelId="combineCaseDetailId"
			:openPopup="isShowPopupCombineCaseDetail"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataCombineCaseDetail"/>

    </PopupRouterView>
</template>
<style scoped>
	#container-table-combine-case {
		padding-top: 0px;
		height: 200px;
  		overflow-y: scroll;
		width: 100%;
		overflow-x: scroll;
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import CombineCase from '@/models/CombineCase/CombineCase';
import CombineCaseList from '@/models/CombineCase/CombineCaseList';
import CombineCaseFilter from '@/filters/CombineCase/CombineCaseFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppLabel from '@/components/AppLabel';
import CombineCaseDetail from '@/models/CombineCase/CombineCaseDetail';
import CombineCaseDetailFilter from '@/filters/CombineCase/CombineCaseDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import CombineCaseDetailInput from '@/views/CombineCase/CombineCaseDetailInput';
import CombineCaseDetailScan from '@/views/CombineCase/CombineCaseDetailScan';
import CombineCaseDetailUpload from '@/views/CombineCase/CombineCaseDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextbox,
		CombineCaseDetailInput,
		CombineCaseDetailScan,
		CombineCaseDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
			combineDate: {required},
			controlCardId: {required},
			partId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				combineDate: { required : "Combine Date is Required."},
				controlCardId: { required : "Control Card is Required."},
				partId: { required : "Part is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsCombineCaseDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard.controlCardNumber', sortable: false}}, 
				{"qtyControlCard": { "class" : "th-qty-control-card", "label" : "Qty", key: 'qtyControlCard', sortable: false}}, 
				{"takenQty": { "class" : "th-taken-qty d-stack-none", "label" : "Qty Used", key: 'takenQty', sortable: false}}, 
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelCombineCaseDetail : {},
			isShowPopupCombineCaseDetail : false,
			isShowPopupUploadCombineCaseDetail : false,
			isShowPopupCombineCaseDetailScan : false,
			filterCombineCase : null,
			currentCombineCasePage : 1,
			combineCasePageSize: 10,
			sortByCombineCase: '',
			sortDescCombineCase: '',
			filterCombineCaseDetail : null,
			currentCombineCaseDetailPage : 1,
			combineCaseDetailPageSize: 10,
			sortByCombineCaseDetail: '',
			sortDescCombineCaseDetail: '',
			sortingByCombineCaseDetail: [],
			combineCaseDetails : [],
			combineCaseDetailId : '',
			totalCombineCaseDetailRow : 0,
			isShowCombineCaseDetailFilter: false,
			isDownloadCombineCaseDetail: false,
			controlCards: [],
			parts: [],
			isPartComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isControlCardComboLoading: false,
			isCombineCaseComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',
			controlCardQrCode: '',
			isScanControlCardLoading: false,
		}
	},
	methods : {
		async addAndPrint() {
			try {
				this.isBusy = true;
				let id = this.model.id;
				let data = await CombineCase.addAndPrint(this, id);
				if(data) {
					this.$router.back();
				} else {
					this.toast({ message: 'Ada sesuatu yang salah ketika menambah dan print data', title: 'Error', variant: 'danger' });
				}
				this.isBusy = false;
			} catch {
				this.isBusy = false;
			}
		},
		async resetData(detailId) {
			let data = await CombineCase.resetData(this, detailId);
			if(data) {
				this.getCombineCase(this.model.id);
			} else {
				this.toast({ message: 'Ada sesuatu yang salah ketika menghapus data', title: 'Error', variant: 'danger' });
			}
		},
		async scanControlCard() {
			try {
				const qrCode = encodeURIComponent(this.controlCardQrCode);
				if(qrCode == null || qrCode == '') {
					this.toast({ message: 'Control card tidak boleh kosong', title: 'Error', variant: 'danger' });
					return;
				}
				this.isBusy = true;
				const id = this.model.id;
				// const response = await this.$http.get(`CombineCase/ScanControlCard?id=${id}&qrcode=${qrCode}`);
				const response = await CombineCase.scanControlCard(this, id, qrCode);
				if (response == null) {
					this.controlCardQrCode = '';
					this.isBusy = false;
					this.toast({message: 'Gagal mendapatkan response control card', title:'Error', variant : 'danger'});
            		return;
				} else {
					this.controlCardQrCode = '';
					this.isBusy = false;
					await this.getCombineCase(id);
				}
			} catch (error) {
				this.controlCardQrCode = '';
				this.isBusy = false;
				// let errors = error.response.data.errors['1'];
				// this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000});
				//this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			}
		},
		getCombineCase : async function(id) {
			this.isBusy = true;
			CombineCase.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				if(this.model.partId != null) {
					promises.push(
						this.getPart(this.model.partId).then(result => { 
							return true; 
						}).catch(error => {
							this.toast({message: 'Gagal mendapatkan data combine case', title:'Error', variant : 'danger'});
							//this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadCombineCase = true;
			this.filterCombineCase.id = this.modelId;
			CombineCase.downloadDataDetail(this, this.filterCombineCase).then(result => {
				this.isDownloadCombineCase = false;
			}).catch(error => { this.isDownloadCombineCase = false; })
		},
		getCombineCaseDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterCombineCaseDetail);
			if (this.modelId == null) return;
			filter.combineCaseId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByCombineCaseDetail != null) {
				this.sortingByCombineCaseDetail[this.sortByCombineCaseDetail] = this.sortDescCombineCaseDetail;
			}
			let currentPage = (this.currentCombineCaseDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalCombineCaseDetailRow + 1;
				let page = Math.ceil(totalData/this.combineCaseDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.combineCaseDetailPageSize = 0;
			// disable paging end
			CombineCaseDetail.getList(this, filter, this.sortingByCombineCaseDetail, currentPage , this.combineCaseDetailPageSize).then(result => {
				this.currentCombineCaseDetailPage = currentPage + 1;
				this.combineCaseDetails = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
					);
				this.combineCaseDetailsFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
					);
				this.totalCombineCaseDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getCombineCases : async function(input) {
			let filter = new CombineCaseFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isCombineCaseComboLoading = true;
			await CombineCase.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.combineCases = result.data
				}
				this.isCombineCaseComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			await ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		onControlCardChange : async function() {
			let item = this.model.controlCardId;
			let controlCardObj = this.controlCards.filter(function(controlCard){ return controlCard.id == item; });
			this.model.controlCard = controlCardObj.length > 0 ? controlCardObj[0] : null;
		},

		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			await Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPart : async function(id) {
			Part.getData(this, id).then(result => {
				this.model.part = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.combineCaseInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					CombineCase.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'combinecaseindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					CombineCase.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'combinecaseindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return CombineCase.updateData(this, model, id)
					.catch((error) => {
						return this.getCombineCase(id);
					});
				}
				return false;
			});
		},
		onHidden() {
			this.getCombineCases();
		},
		addRowDataCombineCaseDetail(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.combineCaseId =  this.modelId;
					CombineCaseDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getCombineCaseDetails(true);
						this.isShowPopupCombineCaseDetail = false;
					})
				} else {
					model.combineCaseId =  this.modelId;
					CombineCaseDetail.createDataDetail(this, model)
					.then(result => {
						this.getCombineCaseDetails(true);
						this.isShowPopupCombineCaseDetail = false;
					})
				}
			}
		},
		async editRowDataCombineCaseDetail(id) {
			this.combineCaseDetailId = id;
			this.isShowPopupCombineCaseDetail = true; 
		},
		async deleteRowDataCombineCaseDetail(id) {
			CombineCaseDetail.deleteData(this, id).then(result => { this.getCombineCaseDetails(); });
		},
		async resetDataCombineCaseDetail() {
			this.combineCaseDetailId = "";
			this.isShowPopupCombineCaseDetail = true;
		},
		async addDataCombineCaseDetail() {
			CombineCaseDetail.createData(this, { combineCaseId: this.modelId })
			.then(result => {
				this.getCombineCaseDetails(true);
			})
		},
		async addFromClipboardCombineCaseDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, combineCaseId: this.modelId });
				});
				CombineCaseDetail.addFromClipboard(this, controlCards).then(result => { this.getCombineCaseDetails() });
			});
		},
		async replaceFromClipboardCombineCaseDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, combineCaseId: this.modelId });
				});
				CombineCaseDetail.replaceFromClipboard(this, controlCards).then(result => { this.getCombineCaseDetails() });
			});   
		},
		showPopupUploadCombineCaseDetail() {
			this.isShowPopupUploadCombineCaseDetail = true;
		},
		uploadDataCombineCaseDetail(modalEvent, newDatas) {
			this.isShowPopupUploadCombineCaseDetail = false; 
		},
		downloadCombineCaseDetail(modalEvent) {
			this.isDownloadCombineCaseDetail = true;
			this.filterCombineCaseDetail.combineCaseId = this.modelId;
			CombineCaseDetail.downloadDataDetail(this, this.filterCombineCaseDetail).then(result => {
				this.isDownloadCombineCaseDetail = false;
			}).catch(error => { this.isDownloadCombineCaseDetail = false; })
		},
		saveInputCombineCaseDetail(item) {
			if (this.combineCases != null && this.combineCases != undefined  && this.combineCases.length > 0) {
				item.combineCase = this.combineCases.find(q => q.id == item.combineCaseId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					CombineCaseDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadCombineCaseDetail = false; 
			this.isShowPopupCombineCaseDetail = false; 
			if (modalType == 'CombineCaseDetail') {
				this.getCombineCaseDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		goToNext(page, item) {
			if(page == 2) {
				this.saveAction();
				return;
			}

		},
	},
	beforeMount() {
		this.filterCombineCase = new CombineCaseFilter();
		this.filterCombineCaseDetail = new CombineCaseDetailFilter();
		//this.getCombineCases();
		//this.getControlCards();
		//this.getParts();
	},
	async mounted(){
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getCombineCase(id);
		}
		this.$nextTick(() => {
			
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		formattedCombineDate() {
			// Create a new Date object from the given string
			const date = new Date(this.model.combineDate);

			// Define an array of month names
			const monthNames = [
				"January", "February", "March", "April", "May", "June", "July",
				"August", "September", "October", "November", "December"
			];

			// Get the day, month, and year components from the date object
			const day = date.getDate();
			const monthIndex = date.getMonth();
			const year = date.getFullYear();

			// Format the date as "dd/Month/yyyy"
			return `${day}/${monthNames[monthIndex]}/${year}`;
		},

		remainingQty() {
			if(this.model.part) {
				const totalQtyTaken = this.model.combineCaseDetail.reduce((total, detail) => total + detail.takenQty, 0);

				return this.model.part.standarPackagingQty - totalQtyTaken;
			} else {
				return null;
			}
		}
	},
	watch : {
	},
}
</script>
